import React from 'react';
import SupplierTable from './SupplierTable';

function InvoiceSuppliersTable({ suppliers, remainedTotal }) {
  return (
    <SupplierTable
      title="Compensi da fatture fornitore"
      suppliers={suppliers}
      anchorId="info-invoice"
      remainedTotal={remainedTotal}
    />
  );
}

export default InvoiceSuppliersTable;
